function Timer(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14.95} height={15.23} {...props}>
      <defs>
        <clipPath id="a">
          <ellipse
            data-name="Ellipse 218"
            cx={7.475}
            cy={7.615}
            rx={7.475}
            ry={7.615}
            transform="translate(5026 11478)"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 40" transform="translate(-5026 -11478)" clipPath="url(#a)">
        <g data-name="Group 6346">
          <g data-name="Group 997">
            <g data-name="Group 995">
              <path
                data-name="Path 4740"
                d="M5033.426 11493a7.124 7.124 0 0 1-5.108-2.2 7.488 7.488 0 0 1 .05-10.424 7.126 7.126 0 0 1 5.105-2.148h.045a7.322 7.322 0 0 1 7.2 7.428 7.412 7.412 0 0 1-2.137 5.192 7.126 7.126 0 0 1-5.105 2.148Z"
                fill="#ffc600"
              />
            </g>
            <g data-name="Group 996">
              <path
                data-name="Path 4741"
                d="M5033.474 11478.464h.043a7.154 7.154 0 0 1-.045 14.3h-.043a7.154 7.154 0 0 1 .045-14.3m0-.464a7.358 7.358 0 0 0-5.27 2.217 7.72 7.72 0 0 0-.051 10.749 7.354 7.354 0 0 0 5.274 2.267h.046a7.357 7.357 0 0 0 5.27-2.217 7.719 7.719 0 0 0 .051-10.749 7.352 7.352 0 0 0-5.274-2.267Z"
                fill="#102770"
              />
            </g>
          </g>
          <g data-name="Group 999" opacity={0.3}>
            <g data-name="Group 998">
              <path
                data-name="Path 4742"
                d="M5040.482 11485.659a7.192 7.192 0 0 0-2.661-5.654 7.2 7.2 0 0 1 2.182 5.23 7.082 7.082 0 0 1-7.053 7.109 6.891 6.891 0 0 1-4.3-1.541 6.91 6.91 0 0 0 4.783 1.965 7.082 7.082 0 0 0 7.049-7.109Z"
                fill="#102770"
              />
            </g>
          </g>
          <g data-name="Group 1000" opacity={0.6}>
            <path
              data-name="Path 4743"
              d="M5039.243 11485.82a5.663 5.663 0 0 0-4.156-5.534l-.044.166.044-.166a5.508 5.508 0 0 0-5.344 1.457 5.731 5.731 0 0 0 2.5 9.541 5.5 5.5 0 0 0 1.387.186 5.639 5.639 0 0 0 5.613-5.65Z"
              fill="#fff"
            />
          </g>
          <g data-name="Group 1003">
            <g data-name="Group 1001">
              <path
                data-name="Path 4744"
                d="M5033.439 11491.157a5.347 5.347 0 0 1-3.834-1.648 5.561 5.561 0 0 1-1.566-3.927 5.5 5.5 0 0 1 5.435-5.507h.033a5.346 5.346 0 0 1 3.834 1.648 5.56 5.56 0 0 1 1.566 3.926 5.5 5.5 0 0 1-5.435 5.508Z"
                fill="#fff"
              />
            </g>
            <g data-name="Group 1002">
              <path
                data-name="Path 4745"
                d="M5033.474 11480.274h.032a5.344 5.344 0 0 1-.034 10.685h-.032a5.344 5.344 0 0 1 .033-10.684m0-.4a5.546 5.546 0 0 0-3.973 1.671 5.761 5.761 0 0 0-1.661 4.034 5.694 5.694 0 0 0 5.6 5.775h.035a5.544 5.544 0 0 0 3.973-1.671 5.817 5.817 0 0 0 .038-8.1 5.542 5.542 0 0 0-3.976-1.708Z"
                fill="#102770"
              />
            </g>
          </g>
          <g data-name="Group 1006" opacity={0.3}>
            <g data-name="Group 1004">
              <path
                data-name="Path 4746"
                d="M5029.124 11488.652a5.418 5.418 0 0 1-.92-3.069 5.336 5.336 0 0 1 5.269-5.343h.032a5.239 5.239 0 0 1 4.682 2.973l-.057.033a5.18 5.18 0 0 0-4.261-2.31h-.032a5.269 5.269 0 0 0-5.2 5.277 5.339 5.339 0 0 0 .547 2.4Z"
                fill="#102770"
              />
            </g>
            <g data-name="Group 1005">
              <path
                data-name="Path 4747"
                d="M5033.473 11480.274h.032a5.226 5.226 0 0 1 4.652 2.955 5.2 5.2 0 0 0-4.288-2.324h-.032a5.29 5.29 0 0 0-5.236 5.31 5.407 5.407 0 0 0 .55 2.419 5.391 5.391 0 0 1-.915-3.05 5.29 5.29 0 0 1 5.236-5.31m0-.066a5.216 5.216 0 0 0-3.737 1.572 5.492 5.492 0 0 0-.639 6.891l.115-.066a5.308 5.308 0 0 1-.543-2.39 5.236 5.236 0 0 1 5.17-5.244h.032a5.146 5.146 0 0 1 4.233 2.295l.115-.066a5.389 5.389 0 0 0-1.905-2.152 5.212 5.212 0 0 0-2.806-.84h-.033Z"
                fill="#102770"
              />
            </g>
          </g>
          <g data-name="Group 1011">
            <g data-name="Group 1007" transform="translate(5032.563 11484.803)">
              <ellipse
                data-name="Ellipse 60"
                cx={0.885}
                cy={0.867}
                rx={0.885}
                ry={0.867}
                transform="rotate(-80.567 1.03 .872)"
                fill="#102770"
              />
            </g>
            <g data-name="Group 1008">
              <path
                data-name="Path 4748"
                d="m5030.927 11483.396 2.272 2.5a.215.215 0 0 0 .369-.1.214.214 0 0 0-.048-.191l-2.238-2.532a.215.215 0 0 0-.3-.017l-.033.03a.215.215 0 0 0-.022.31Z"
                fill="#102770"
              />
            </g>
            <g data-name="Group 1009">
              <path
                data-name="Path 4749"
                d="m5033.632 11485.012 1.417-1.917a.465.465 0 0 1 .672-.08.465.465 0 0 1 .074.635l-1.75 2.345Z"
                fill="#102770"
              />
            </g>
            <g data-name="Group 1010">
              <path
                data-name="Path 4750"
                d="m5033.747 11486.414.529.593a.122.122 0 0 0 .172.01l.153-.135a.12.12 0 0 0 .008-.172l-.571-.617Z"
                fill="#102770"
              />
            </g>
          </g>
          <g data-name="Group 1012" opacity={0.6}>
            <path
              data-name="Path 4751"
              d="M5033.517 11478.464a6.873 6.873 0 0 0-3.529.946 7.1 7.1 0 0 0-1.934 1.672 7.254 7.254 0 0 0 .931 10.029 7.254 7.254 0 0 1-.608-10.018 2.084 2.084 0 0 0 1.063-.682 2.577 2.577 0 0 0 .425-.634 6.9 6.9 0 0 1 8.288.515 6.9 6.9 0 0 0-4.636-1.828Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Timer;
